import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class clientService {

  constructor(private http: HttpClient) { }
  getClientData(data:any): Observable<any> {
    return this.http.post(environment.getClientConfig,data);
  }
}
